mutation Inertia_CreateInvitation($companyId: ID!, $email: String!, $role: MemberRoleEnum!) {
  createInvitation(input: { companyId: $companyId, email: $email, role: $role }) {
    invitation {
      id
      email
      role
    }
    errors
  }
}